export default __webpack_public_path__ + "static/media/terraform.b8e0d522.svg";